import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import FieldSet from 'flarum/common/components/FieldSet';
import { extend } from 'flarum/common/extend';
import PhoneVerificationModal from './components/PhoneVerificationModal';
import { phoneStatus, setPhoneStatus } from './status';
let verificationNotice = null;
async function updateVerifiedAccess(status) {
  setPhoneStatus(status);
  app.alerts.dismiss(verificationNotice);
  verificationNotice = null;
  try {
    // Reload authoritative permissions; never simply set canStartDiscussion or
    // canReply to true, since other moderation/tag restrictions still apply.
    const forum = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/'
    });
    app.store.pushPayload(forum);
    const discussion = app.current.get('discussion');
    if (app.current.matches('flarum/forum/components/DiscussionPage') && discussion) {
      await app.store.find('discussions', discussion.id());
    }
  } catch {
    app.alerts.show({
      type: 'warning'
    }, m("span", null, app.translator.trans('aooci-phone-verification.forum.notice.refresh_failed'), ' ', m(Button, {
      className: "Button Button--link",
      onclick: () => window.location.reload()
    }, app.translator.trans('aooci-phone-verification.forum.notice.refresh'))));
  }
  m.redraw();
}
function showModal() {
  const status = phoneStatus();
  if (!status) {
    return;
  }
  app.modal.show(PhoneVerificationModal, {
    mode: status.mode,
    onVerified: updateVerifiedAccess
  });
}
function statusText(status) {
  if (status.verified) {
    return app.translator.trans('aooci-phone-verification.forum.settings.verified', {
      phone: status.maskedPhone
    });
  }
  if (!status.providerReady) {
    return app.translator.trans('aooci-phone-verification.forum.settings.unavailable');
  }
  return status.required ? app.translator.trans('aooci-phone-verification.forum.settings.required') : app.translator.trans('aooci-phone-verification.forum.settings.optional');
}
app.initializers.add('aooci-phone-verification', () => {
  extend('flarum/forum/components/SettingsPage', 'settingsItems', function (items) {
    const status = phoneStatus();
    if (!status || status.mode === 'off') {
      return;
    }
    items.add('aoociPhoneVerification', m(FieldSet, {
      className: "Settings-phoneVerification FieldSet--form",
      label: app.translator.trans('aooci-phone-verification.forum.settings.heading')
    }, m("div", {
      className: "Form-group"
    }, m("p", {
      className: "helpText"
    }, statusText(status)), !status.verified && status.providerReady ? m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-mobile-screen-button",
      onclick: showModal
    }, app.translator.trans('aooci-phone-verification.forum.settings.button')) : null)), -90);
  });
  app.beforeMount(() => {
    if (!app.session.user) {
      return;
    }
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/aooci/phone/status'
    }).then(status => {
      setPhoneStatus(status);
      m.redraw();
      if (status.required && status.providerReady) {
        verificationNotice = app.alerts.show({
          type: 'info',
          dismissible: true
        }, m("span", null, app.translator.trans('aooci-phone-verification.forum.notice.required'), ' ', m(Button, {
          className: "Button Button--link",
          onclick: showModal
        }, app.translator.trans('aooci-phone-verification.forum.notice.action'))));
      }
    });
  });
});